import { useMutation } from "react-query";
import { AuthApi } from "@api/AuthApi";

export const useSendResetPasswordEmail = () => {
  return useMutation("user", AuthApi.sendResetPasswordEmail);
};
